import NoticeReg from "../../../../components/units/Edgecross/Announcement/Notice/Register/NoticeReg";

export default function NoticeRegisterPage() {
  return <NoticeReg />;
}
